import { FormattedMessage } from 'react-intl';

const MORE_INFO_URL =
  'https://hiveon.com/news/hiveon-pool-service-termination-what-you-need-to-know/';

const TerminationAlert = () => (
  <div
    role="alert"
    className="-mx-4 -mb-4 sm:-mb-6 mt-4 sm:mt-6 py-2 px-4 bg-custom-FF504C text-white text-center text-sm font-medium"
  >
    <FormattedMessage
      id="header.termination.alert"
      defaultMessage="Hiveon Pool service has been terminated on May 15. <a>More info</a>"
      values={{
        a: (chunks) => (
          <a
            href={MORE_INFO_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            {chunks}
          </a>
        ),
      }}
    />
  </div>
);

export default TerminationAlert;
